module.exports = __webpack_public_path__ + "static/media/cr2.69c0d488.png";